












import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import notificationService from '@/services/notificationService';
import ordersService from '@/modules/orders/ordersService';
import cPopup from '@/components/default/Popup.vue';
import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';

import customersRepository from '@/services/customers/customersRepository';
import projectsRepository from '@/services/projectsRepository';

import { OrderType } from '@/modules/orders/enums';
import { ProjectsClient } from '@/data/web-api-client';

@Component({
  components: {
    cPopup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
  },
})
export default class CreateOrderPopup extends Vue {
  @Prop({ required: false })
  projectId?: string;

  show: boolean = false;
  saving: boolean = false;
  model: IOrderCreateCommand = {
    projectId: '',
    supplierId: '',
    type: 0,
  };

  loading: boolean = false;

  projectsClient: ProjectsClient = new ProjectsClient(undefined, this.$axios);

  public open() {
    this.show = true;
  }

  mounted() {
    if (this.projectId) {
      this.model.projectId = this.projectId;
    }
  }

  async save() {
    try {
      const validationResult = (this.$refs.CreateOrderForm as any).instance.validate();
      if (validationResult.isValid) {
        this.saving = true;

        await ordersService.createManual(this.model);

        notificationService.saved();
        this.$emit('saved');
      } else {
        notificationService.invalidForm();
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
      this.show = false;
      Object.assign(this.model, {
        projectId: '',
        supplierId: '',
        type: 0,
      });

      if (this.projectId) {
        this.model.projectId = this.projectId;
      }
    }
  }

  get customersOptions() {
    const self = this;
    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
          load: async (loadOptions) => {
            if (Array.isArray(loadOptions.filter) && loadOptions.filter.length > 1 && loadOptions.filter[0] === 'id') {
              return {
                data: [],
                totalCount: 0,
              };
            }
            const result = await customersRepository.get(loadOptions);
            return {
              data: result.data,
            };
          },
          byKey: (val: any) => {
            return val;
          },
        }),
        paginate: true,
      }),
      valueExpr: 'id',
      displayExpr: 'displayName',
      searchEnabled: true,
    };
  }

  get projectsOptions() {
    const self = this;
    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
          key: 'id',
          load: async (loadOptions: any) => {
            if (Array.isArray(loadOptions.filter) && loadOptions.filter.length > 1 && loadOptions.filter[0] === 'id') {
              return {
                data: [],
                totalCount: 0,
              };
            }
            if (loadOptions.searchExpr && loadOptions.searchValue && loadOptions.searchOperation) {
              loadOptions.filter = [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];
            }

            const result = await projectsRepository.lookup(loadOptions);
            return {
              data: result.data.data,
              totalCount: result.data.totalCount,
            };
          },
          byKey: async (val: any) => {
            if (val) {
              return await this.projectsClient.getProjectBasicInfo(val).then((result: any) => {
                return result;
              });
            }
          },
        }),
        paginate: true,
      }),
      valueExpr: 'id',
      displayExpr: 'name',
      searchExpr: 'name',
      searchEnabled: true,
      showClearButton: true,
    };
  }

  get fields() {
    return [
      {
        itemType: 'simple',
        dataField: 'supplierId',
        editorOptions: this.customersOptions,
        editorType: 'dxSelectBox',
        label: {
          text: 'Leverancier',
        },
        validationRules: [{ type: 'required', message: 'Veld is verplicht' }],
      },
      {
        itemType: 'simple',
        dataField: 'projectId',
        editorOptions: this.projectsOptions,
        editorType: 'dxSelectBox',
        label: {
          text: 'Project',
        },
      },
      {
        itemType: 'simple',
        dataField: 'type',
        editorOptions: {
          items: [
            { value: OrderType.MaterialsOrder, text: 'Materiaal' },
            { value: OrderType.SubcontractorSettlement, text: 'Afrekening' },
            { value: OrderType.Other, text: 'Andere' },
          ],
          valueExpr: 'value',
          displayExpr: 'text',
          searchEnabled: true,
        },
        editorType: 'dxSelectBox',
        label: {
          text: 'Soort',
        },
        validationRules: [{ type: 'required', message: 'Veld is verplicht' }],
      },
    ];
  }
}
